(function () {
    init();

    function init() {
        const bannerComponents = document.querySelectorAll('.last-order-banner');
        const countdownBannerComponents = [];

        for (const banner of bannerComponents) {
            const bannerTextComponent = banner.querySelector('p');
            const deliveryText = banner.dataset.deliveryText;
            const bannerType = banner.dataset.bannerType;

            if (!banner.dataset.deliveryDateInSeconds) continue;

            const deliveryDateTimestamp = parseInt(banner.dataset.deliveryDateInSeconds) * 1000;

            if (isNaN(deliveryDateTimestamp)) {
                console.error('Invalid timestamp');
                continue;
            }

            if (bannerType === 'countdown') {
                countdownBannerComponents.push({
                    banner,
                    bannerTextComponent,
                    deliveryText,
                    localDateTimestamp: deliveryDateTimestamp
                });
                performUpdate(deliveryDateTimestamp, bannerTextComponent, deliveryText, true);
                continue;
            }

            // Static banner logic
            if (bannerTextComponent) {
                bannerTextComponent.innerHTML = deliveryText.replace('DATE_PLACEHOLDER', convertDateToDDMM(new Date(deliveryDateTimestamp)));
            }
        }

        if (window.bannerCountdownInterval) {
            clearInterval(window.bannerCountdownInterval);
        }

        if (countdownBannerComponents.length) {
            if (countdownBannerComponents.length === 1) {
                countdownBannerComponents[0].banner.style.display = 'inline-flex';
            }
            startCountdown(countdownBannerComponents);

        }
    }

    function performUpdate(countdownEndDateTimestamp, bannerTextComponent, deliveryText, overrideDisplayCheck = false) {
        if(!bannerTextComponent) return;

        const now = Date.now();
        const dist = countdownEndDateTimestamp - now;

        if (dist < 0) {
            if(bannerTextComponent.parentElement) {
                bannerTextComponent.parentElement.style.display = 'none';
            }
            return;
        }

        if (overrideDisplayCheck || bannerTextComponent.parentNode.style.display !== 'none') {
            const hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((dist % (1000 * 60)) / 1000);

            bannerTextComponent.innerHTML = deliveryText.replace('DATE_PLACEHOLDER', `${hours > 0 ? `${hours}h ` : ''}${minutes}m ${seconds}s`);
        }
    }

    function startCountdown(countdownBanners) {
        window.bannerCountdownInterval = setInterval(() => {

            for (let i = countdownBanners.length - 1; i >= 0; i--) {
                if (!countdownBanners[i].banner.isConnected) {
                    countdownBanners.splice(i, 1);
                }
            }

            if (countdownBanners.length === 0) {
                clearInterval(window.bannerCountdownInterval);
                return;
            }

            for (const countdownBanner of countdownBanners) {
                const { bannerTextComponent, localDateTimestamp, deliveryText } = countdownBanner;
                performUpdate(localDateTimestamp, bannerTextComponent, deliveryText);
            }

        }, 1000);
    }

    function convertDateToDDMM(date) {
        const day = date.getDate();
        const month = date.toLocaleString('en-US', { month: 'long' });
        let suffix = 'th';

        if (day < 11 || day > 13) {
            switch (day % 10) {
                case 1: suffix = 'st'; break;
                case 2: suffix = 'nd'; break;
                case 3: suffix = 'rd'; break;
            }
        }
        return `${day}${suffix} ${month}`;
    }
})();